export const CREATE_PAYMENT_DIALOG = "CREATE_PAYMENT_DIALOG"
export const CREATE_PAYMENT_SELECTED_ITEM = "CREATE_PAYMENT_SELECTED_ITEM"
export const IS_PAYMENT_LOADED = "IS_PAYMENT_LOADED"
export const IS_BOOKING_LOADED = "IS_BOOKING_LOADED"
export const IS_CREATE_PAYMENT_ENABLE = "IS_CREATE_PAYMENT_ENABLE"

